export interface IContentProgramsResponse {
  sanity_ids: string[]
}

export enum contentProgramTypes {
  ContentEvent = 'plusEventPortal',
  ContentReadTogether = 'contentReadTogether',
  ContentReadAlone = 'contentReadAlone',
}
